import { Check } from "lucide-react";
import { Reveal } from "../../lib/motion";
import { PROPERTY, PRICING, CTA_LABEL } from "../../data";

export const Pricing = ({ onRequestPackage }) => {
  return (
    <section id="pricing" className="py-24 md:py-32 bg-navy text-white scroll-mt-20">
      <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
        <Reveal>
          <span className="label-caps text-xs text-water">Pricing</span>
          <h2 className="font-serif text-4xl md:text-5xl font-light mt-4 leading-tight">
            Current Asking Price
          </h2>
          <p className="mt-4 text-white/70 leading-relaxed">
            {PRICING.assessmentNote}
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div
            data-testid="pricing-card"
            className="mt-12 bg-white/[0.04] border border-white/10 rounded-3xl p-8 md:p-12 text-left"
          >
            <div className="text-center pb-8 border-b border-white/10">
              <div className="label-caps text-[11px] text-water">Current Asking Price</div>
              <div className="mt-2 font-serif text-5xl md:text-6xl text-white">{PROPERTY.price}</div>
              <div
                data-testid="pricing-previous-price"
                className="mt-3 text-sm text-white/55"
              >
                Previously offered at <span className="line-through">{PROPERTY.previousPrice}</span>
              </div>
              <div
                data-testid="pricing-reduction-badge"
                className="mt-4 inline-flex items-center gap-2 bg-water/15 border border-water/30 rounded-full px-4 py-1.5"
              >
                <span className="label-caps text-[10px] tracking-[0.2em] text-water">
                  {PROPERTY.priceReductionAmount} Price Reduction
                </span>
              </div>
            </div>

            <p className="mt-8 text-sm text-white/70 leading-relaxed">{PRICING.paragraph}</p>

            <ul className="mt-8 space-y-3">
              {PRICING.features.map((f) => (
                <li key={f} className="flex items-start gap-3">
                  <div className="mt-0.5 w-6 h-6 rounded-full bg-water/15 flex items-center justify-center shrink-0">
                    <Check size={14} className="text-water" />
                  </div>
                  <span className="text-white/90">{f}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 text-center">
              <button
                data-testid="pricing-request-btn"
                onClick={onRequestPackage}
                className="bg-water text-white rounded-full px-8 py-3.5 font-medium hover:bg-water-soft transition-colors shadow-sm hover:shadow-md focus-visible:ring-2 focus-visible:ring-water focus-visible:outline-none"
              >
                {CTA_LABEL}
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
